import type { RegisteredServices } from '@/core/container/types'

export const contactsImportedTable = 'contactsImportedTable' as RegisteredServices
export const contactsDuplicatesTable = 'contactsDuplicatesTable' as RegisteredServices
export const contactsFailedTable = 'contactsFailedTable' as RegisteredServices
export const contactsExcludedTable = 'contactsExcludedTable' as RegisteredServices
export const contactsUnsubscribedTable = 'contactsUnsubscribedTable' as RegisteredServices
